<template>
    <form-container :headerText="title" :width="400" action="editBewerb" :header-sub-text="subtitle"
                    :valid-actions="['editBewerb']" @save="save()">
        <div v-if="rules && bewerb" class="px-7 pb-3">
            <v-text-field label="Datum" v-model="bewerb.settings.datum" hide-details class="mb-4"/>
            <v-text-field label="Ort" v-model="bewerb.settings.ort" hide-details class="mb-4"/>
            <v-text-field label="Bahn" v-model="bewerb.settings.bahn" hide-details class="mb-4"/>
            <v-text-field label="Schiedsrichter" v-model="bewerb.settings.schiedsrichter" hide-details class="mb-4"/>
            <v-text-field label="Livestream Url" v-model="bewerb.settings.liveStream" hide-details/>
            <div class="grey--text text--darken-1 mt-6" style="font-size: 13px">Bitte wähle den Turniermodus:</div>
            <v-radio-group v-model="bewerb.settings.modus" :rules="[rules.required]">
                <v-radio v-for="(type, n) in modusOptionen"
                         :key="n"
                         :label="type.label"
                         :value="type.value"
                         :disabled="bewerb.id!==null"
                ></v-radio>
            </v-radio-group>
            <div class="grey--text text--darken-1"
                 style="font-size: 13px">Maximale Anzahl an teilnehmenden {{bewerbMasterData.plural}}</div>
            <v-radio-group v-model="bewerb.settings.anzahlStarterMax" :rules="[rules.required]" row>
                <v-radio v-for="(anzahl) in anzahlStarter" :key="anzahl.value"
                         :label="anzahl.label" :value="anzahl.value"
                         class="mb-2 mr-4"
                         :disabled="bewerb.id!==null"
                ></v-radio>
            </v-radio-group>
            <div v-if="bewerb.settings.anzahlStarterMax && bewerb.settings.modus === 'tabelle_ko'">
                <div class="grey--text text--darken-1"
                     style="font-size: 13px">Wieviele der teilnehmenden {{bewerbMasterData.plural}} steigen aus der Qualifikation
                    in die erste K.o.-Runde auf?</div>
                <v-radio-group v-model="teamsToKoMax" :rules="[rules.required]" row>
                    <v-radio v-for="(anzahl) in anzahlStarter.filter(
                                    starter => starter.value <= bewerb.settings.anzahlStarterMax)"
                             :key="anzahl.value" :label="anzahl.label" :value="anzahl.value"
                             class="mb-2 mr-4"
                             :disabled="bewerb.id!==null"
                    ></v-radio>
                </v-radio-group>
            </div>
            <div v-if="bewerb.settings.modus && bewerb.settings.modus !== 'tabelle'">
                <div v-if="bewerb.rankingPlatz5bis8Required(teamsToKoMax)">
                    <div class="grey--text text--darken-1"
                         style="font-size: 13px">Wie soll Platz 5 - 8  ermittelt werden?</div>
                    <v-radio-group v-model="rankingPlatz5bis8" :rules="[rules.required]" row>
                        <v-radio v-for="(option) in rankingPlatz5bis8Options"
                                 :key="option.value" :label="option.label" :value="option.value"
                                 class="mb-2 mr-4"
                        ></v-radio>
                    </v-radio-group>
                </div>
                <div v-if="bewerb.rankingPlatz3bis4Required(teamsToKoMax)">
                    <div class="grey--text text--darken-1"
                         style="font-size: 13px">Wie soll Platz 3 und 4 ermittelt werden?</div>
                    <v-radio-group v-model="rankingPlatz3bis4" :rules="[rules.required]" row>
                        <v-radio v-for="(option) in rankingPlatz3bis4Options"
                                 :key="option.value" :label="option.label" :value="option.value"
                                 class="mb-2 mr-4"
                                 :disabled="(bewerb.id!==null && option.value === 'ko') ||
                                            (bewerb.id!==null && option.value !== 'ko' &&
                                            rankingPlatz3bis4==='ko') "
                        ></v-radio>
                    </v-radio-group>
                </div>
                <div class="grey--text text--darken-1"
                     style="font-size: 13px">Bitte gib Daten zu den Spielen ein?</div>
                <v-text-field v-model="saetze" :rules="[rules.required]"
                              label="Anzahl Sätze" clearable type="number" :disabled="bewerb.id!==null"/>
                <v-text-field v-model="wuerfeProSatz" :rules="[rules.required]"
                              label="Würfe pro Satz" clearable type="number" :disabled="bewerb.id!==null"/>
                <!--<v-text-field v-model="dauerGeplant" :rules="[rules.required]"
                              label="Geplante Spieldauer" clearable type="time"/>-->
            </div>
            <error-msg :error="error"></error-msg>
        </div>
    </form-container>
</template>

<script>
    import FormContainer from "@/components/form/formContainer";
    import {FormRules} from "@/services/formRules";
    import ErrorMsg from "@/components/elements/errorMsg";
    import {Bewerb} from "@/services/data/meisterschaften/bewerb";
    import {BEWERB_ANZAHL_STARTER, BEWERB_KO_PLATZ_3_BIS_4, BEWERB_KO_PLATZ_5_BIS_8, BEWERB_MODUS_OPTIONEN,
        MEISTERSCHAFT_BEWERBE} from "@/services/data/meisterschaften/bewerb_constants";

    export default {
        components: {ErrorMsg, FormContainer},
        name: "meisterschaft-bewerb-edit",
        props: ['currentData', 'header', 'liga', 'sportJahr', 'spielTyp'],
        data: () => ({
            modusOptionen: BEWERB_MODUS_OPTIONEN,
            anzahlStarter: BEWERB_ANZAHL_STARTER,
            meisterschaftBewerbe: MEISTERSCHAFT_BEWERBE,
            rankingPlatz5bis8Options: BEWERB_KO_PLATZ_5_BIS_8,
            rankingPlatz3bis4Options: BEWERB_KO_PLATZ_3_BIS_4,
            rules: null,
            bewerb: null,
            error: '',
            teamsToKoMax: null,
            rankingPlatz5bis8: null,
            rankingPlatz3bis4: null,
            saetze: null,
            wuerfeProSatz: null,
            dauerGeplant: '00:00',
        }),
        computed: {
            title(){ return this.currentData?.id ? 'Bewerb ändern' : 'Bewerb anlegen'},
            bewerbMasterData (){ return this.meisterschaftBewerbe.find(bewerb => bewerb.value === this.$route.query.bewerbTyp) },
            subtitle(){ return this.header + ' ' + this.bewerbMasterData.label },
            editBewerbParam(){ return this.$route.query.action === 'editBewerb' },
        },
        created(){
            this.rules = new FormRules();
            if( this.editBewerbParam ) this.init()
        },
        methods: {
            init(){
                this.teamsToKoMax = null;
                this.saetze = null;
                this.wuerfeProSatz = null;
                this.dauerGeplant = '00:00';
                this.rankingPlatz3bis4 = null;
                this.rankingPlatz5bis8 = null;
                this.bewerb = new Bewerb(this.currentData, this.liga.id.split('_')[0],
                                                this.liga.id, this.spielTyp, this.sportJahr,
                                                this.liga.name, this.liga.type)
                if ( !this.bewerb.settings.bewerbType ) this.bewerb.settings.bewerbTyp = this.$route.query.bewerbTyp;
                if ( this.currentData ) {
                    this.teamsToKoMax = this.bewerb.settings.teamsToKoMax;
                    this.saetze = this.bewerb.settings.spiel.saetze;
                    this.wuerfeProSatz = this.bewerb.settings.spiel.wuerfeProSatz;
                    this.dauerGeplant = this.bewerb.settings.spiel.dauerGeplant;
                    this.rankingPlatz3bis4 = this.bewerb.settings.rankingPlatz3bis4;
                    this.rankingPlatz5bis8 = this.bewerb.settings.rankingPlatz5bis8;
                }
            },
            async save(){
                // set variable parameters
                    this.bewerb.settings.teamsToKoMax = this.bewerb.settings.modus === 'tabelle_ko' ?
                                                        this.teamsToKoMax : null;
                    this.bewerb.settings.rankingPlatz3bis4 = this.bewerb.settings.modus !== 'tabelle' ?
                                                        this.rankingPlatz3bis4 : null;
                    this.bewerb.settings.rankingPlatz5bis8 = this.bewerb.settings.modus !== 'tabelle' ?
                                                        this.rankingPlatz5bis8 : null;
                    this.bewerb.settings.spiel.saetze = this.bewerb.settings.modus !== 'tabelle' ?
                                                        parseInt(this.saetze) : null;
                    this.bewerb.settings.spiel.wuerfeProSatz = this.bewerb.settings.modus !== 'tabelle' ?
                                                        parseInt(this.wuerfeProSatz) : null;
                    this.bewerb.settings.spiel.dauerGeplant = this.bewerb.settings.modus !== 'tabelle' ?
                                                        this.dauerGeplant : null;
                // save
                    this.$store.state.local.loader = true;
                    let reply = null
                    if ( !this.bewerb.id ) {
                        const id = this.liga.id + '_' + this.sportJahr + '_' + this.bewerb.settings.bewerbTyp;
                        reply = await this.bewerb.create(id)
                    } else {
                        reply = await this.bewerb.update({settings: this.bewerb.settings})
                    }
                    if ( reply.successful ) {
                        this.$emit('bewerbChanged', JSON.parse(JSON.stringify(this.bewerb)));
                        this.bewerb = null
                        window.history.back();
                    } else {
                        this.error = 'Beim Speichern ist ein Fehler aufgetreten. Bitte wende dich an den' +
                            'System-Administrator! ' + reply.error;
                    }
                    this.$store.state.local.loader = false;
            },
        },
        watch: {
            editBewerbParam(to){ if ( to ) this.init() },
        }
    }
</script>

<style scoped>

</style>